import React, { useEffect, createElement } from 'react';
export const MetaPixel = () => {
  useEffect(() => {
    // Initialize Facebook Pixel
    if (window.fbq) {
      // If already initialized, just track pageview
      window.fbq('track', 'PageView');
      return;
    }
    // Create fbq function
    const fbq = function () {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, arguments);
      } else {
        fbq.queue.push(arguments);
      }
    };
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    window.fbq = fbq;
    window._fbq = fbq;
    // Load the Facebook Pixel script and append to body
    const script = document.createElement('script');
    script.id = 'facebook-pixel-script';
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    script.onload = () => {
      // Initialize and track after script loads
      window.fbq('init', '527906828002058');
      window.fbq('track', 'PageView');
      console.log('Meta Pixel initialized and PageView tracked');
    };
    // Insert script at the beginning of body (right after <body> tag)
    if (document.body.firstChild) {
      document.body.insertBefore(script, document.body.firstChild);
    } else {
      document.body.appendChild(script);
    }
  }, []);
  return <>
      {/* Noscript fallback - renders right after body tag */}
      <noscript data-id="element-116">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=527906828002058&ev=PageView&noscript=1" alt="" data-id="element-117" />
      </noscript>
    </>;
};
// TypeScript declarations
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}